import { render, staticRenderFns } from "./news6.vue?vue&type=template&id=87b15c58&scoped=true"
import script from "./news6.vue?vue&type=script&lang=js"
export * from "./news6.vue?vue&type=script&lang=js"
import style0 from "./news6.vue?vue&type=style&index=0&id=87b15c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b15c58",
  null
  
)

export default component.exports